import { render, staticRenderFns } from "./Setbank.vue?vue&type=template&id=f7f2318a&scoped=true"
import script from "./Setbank.vue?vue&type=script&lang=js"
export * from "./Setbank.vue?vue&type=script&lang=js"
import style0 from "./Setbank.vue?vue&type=style&index=0&id=f7f2318a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f2318a",
  null
  
)

export default component.exports